export default "__VITE_ASSET__6206ea19__"